import { AbstractControl } from '@angular/forms';

export class GpsLongitudeValidation {

  static ValidateDecimal = (region: string) => {
    return (control: AbstractControl) => {
      /*if (region === 'Boston Region') {
        const rex: RegExp = /^-?\d+(\.\d{1,12})?$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal12: true }
        }
        return null;
      }
      else {
        const rex: RegExp = /^-?\d+(\.\d{1,6})?$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal6: true }
        }
        return null;
      }*/
      const rex: RegExp = /^-?\d+(\.\d{6,12})+$/;
        if (!rex.test(control.value) && control.value !== '') {
          return { validateDecimal: true }
        }
        return null;
    }
  }

  static ValidateRange = (region: string) => {
    return (control: AbstractControl) => {
      /*if (region === 'Boston Region') {
        if (((control.value*(-1)) <= 74.000000 && (control.value*(-1)) >= 68.071289)) {

        }
        else {
          return { validateRange: 'Longitude Coordinates Should be in between -68.071289 to -74. Please Verify !' }
        }
        return null;
      }
      if (region === 'Beltway Region') {
        if (((control.value*(-1)) <= 83.0 && (control.value*(-1)) >= 73.3)) {

        }
        else {
          return { validateRange: 'Longitude Coordinates Should be in between -73.3 to -83. Please Verify !' }
        }
        return null;
      }
      if (region === 'Freedom Region') {
        if (((control.value*(-1)) <= 76.1 && (control.value*(-1)) >= 73.8)) {

        }
        else {
          return { validateRange: 'Longitude Coordinates Should be in between -73.8 to -76.1. Please Verify !' }
        }
        return null;
      }
      if (region === 'Keystone Region') {
        if (((control.value*(-1)) <= 82.3 && (control.value*(-1)) >= 75.1)) {

        }
        else {
          return { validateRange: 'Longitude Coordinates Should be in between -75.1 to -82.3. Please Verify !' }
        }
        return null;
      }*/
      if (((control.value*(-1)) <= 130 && (control.value*(-1)) >= 65)) {

      }
      else {
        return { validateRange: 'Longitude Coordinates Should be between -65 to -130. Please Verify !' }
      }
    }
  }
}
